module.exports = __webpack_public_path__ + "img/vk-black.5b8d42cc.svg";